export default __webpack_public_path__ + "static/media/close.0c177262.svg";